<template>
	<div class="boxTop">
		<div class="txt-18">{{ $t('划转记录') }}</div>
		<div class="table">
			<!-- 表头 -->
			<el-row class="header">
				<el-col :span="5" class="elItem">{{ $t('时间') }}</el-col>
				<el-col :span="4" class="elItem">{{ $t('币种') }}</el-col>
				<el-col :span="5" class="elItem">{{ $t('数量') }}</el-col>
				<el-col :span="5" class="elItem">{{ $t('从') }}</el-col>
				<el-col :span="5" class="elItem">{{ $t('至') }}</el-col>
			</el-row>
			<!-- 数据 -->
			<div class="scroll">
				<el-row v-for="(item, index) in list" :key="index + 'a'" class="row">
					<el-col :span="5" class="trade">
						{{ item.createtime }}
					</el-col>
					<el-col :span="4" class="trade">
						{{ item.coin_name }}
					</el-col>
					<el-col :span="5" class="trade">
						{{ item.amount }}
					</el-col>
					<el-col :span="5" class="trade">
						{{ item.from_account }}
					</el-col>
					<el-col :span="5" class="trade">
						{{ item.to_account }}
					</el-col>
				</el-row>
			</div>
		</div>
		<oPage v-if="page.total > page.limit" :current-page.sync="page.page" :page-size.sync="page.limit"
			style="margin-top: 16px;" :total="page.total" @current-change="getdata" />
	</div>
</template>

<script>
import { get } from '@/http/request'
import apis from '@/http/api'
import oPage from '@/common/pc/oPage.vue'
export default {
	components: {
		oPage,
	},
	props: {
	},
	data() {
		return {
			list: [],
			page: {
				page: 1,
				limit: 15,
				total: 10,
			},
		};
	},
	watch: {
	},
	methods: {

		init() {
			this.page.page = 1
			this.getdata(false)
		},
		getdata(showLoading = true) {
			get(apis.transferList, {
				showLoading,
				...this.page
			}).then(res => {
				if (res.code != 1) return
				this.list = res.data.list
				this.page.total = res.data.total || 0
			})
		},
	},
};
</script>
<style lang="scss" scoped>
.boxTop {
	border-radius: 12px;
	border: 2px solid #2c2c3e;
	min-height: 600px;
	padding: 20px 30px;
	margin-top: 20px;
}

.table {
	color: #fff;
	margin-top: 20px;
	font-size: 14px;

	.header {
		background: #1c222c;
		padding: 12px 0;
		border-radius: 5px;

		.elItem {
			text-align: center;
		}
	}

	// .scroll {
	// 	overflow-y: auto;
	// 	height: 45vh;
	// 	scrollbar-width: none;
	// 	/* Firefox */
	// 	-ms-overflow-style: none;
	// 	/* IE/Edge */
	// }

	.row {
		border-bottom: 1px solid #222b39;
		padding: 12px 0px;
		display: flex;
		align-items: center;
		font-size: 14px;

		.trade {
			text-align: center;
		}
	}
}
</style>